/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { AutocompleteApiResult } from '@zcode/bizos'
import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { State } from '@zcode/state-type'
import type { Dispatch } from '../../types'
import { getCommonProps } from '../helpers/getCommonProps'

const getNameFromResult = (autocompleteResult: AutocompleteApiResult) => {
  const { city, name, state, type } = autocompleteResult || {}
  if (type === 'city') {
    return `${name}, ${state}`
  }
  return `${name}, ${city && `${city}, `} ${state}`
}

export const mixpanelAutocompleteResultClick =
  ({ result, index }: { result: AutocompleteApiResult; index: number }) =>
  (dispatch: Dispatch, getState: () => State) => {
    const state = getState()

    const payload: { [key: string]: any } = {
      ...getCommonProps({ state }),
      [PROP_NAMES.RESULT_INDEX]: index,
    }

    const { city, state: resultState, type } = result

    const selectedResult = getNameFromResult(result)

    if (type) {
      payload[PROP_NAMES.RESULT_TYPE] = type
    }

    if (selectedResult) {
      payload[PROP_NAMES.SELECTED_RESULT] = selectedResult
    }

    if (city && resultState) {
      payload[PROP_NAMES.CITY_STATE] = `${city}, ${resultState}`
    }

    if (index) {
      payload[PROP_NAMES.RESULT_INDEX] = index
    }

    track({ event: EVENT_NAMES.CLICK_AUTOCOMPLETE_RESULT, payload })
  }
